<script setup>
import {__} from "../../../assets/javascripts/library";
import {ref} from "vue";

const props = defineProps({
  invoice: {
    type: Object,
    default: () => ({})
  }
})
</script>

<template>
  <table class="travel_allowance">
    <tr>
      <td>{{__('Total distance', 'mareike')}}:</td>
      <td>{{props.invoice.distance}}km</td>
      <td></td>
    </tr>

    <tr>
      <td>{{__('Distance allowance', 'mareike')}}:</td>
      <td>{{props.invoice.distance_allowance}}Euro  / km</td>
      <td></td>
    </tr>

    <tr>
      <td>{{__('Carriage of material', 'mareike')}}:</td>
      <td>{{props.invoice.material}}</td>
      <td></td>
    </tr>

    <tr>
      <td>{{__('Passengers in car', 'mareike')}}:</td>
      <td>{{props.invoice.passengers}}</td>
      <td></td>
    </tr>
  </table>

</template>

<style scoped>
  .travel_allowance tr td:first-child {
    width: 100px !important;
  }
</style>